var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCashIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 15,
    viewBox: "0 0 22 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.44444 0C1.09618 0 0 1.12109 0 2.5V12.5C0 13.8789 1.09618 15 2.44444 15H19.5556C20.9038 15 22 13.8789 22 12.5V2.5C22 1.12109 20.9038 0 19.5556 0H2.44444ZM4.88889 12.5H2.44444V10C3.79271 10 4.88889 11.1211 4.88889 12.5ZM2.44444 5V2.5H4.88889C4.88889 3.87891 3.79271 5 2.44444 5ZM17.1111 12.5C17.1111 11.1211 18.2073 10 19.5556 10V12.5H17.1111ZM19.5556 5C18.2073 5 17.1111 3.87891 17.1111 2.5H19.5556V5ZM11 3.75C11.9725 3.75 12.9051 4.14509 13.5927 4.84835C14.2804 5.55161 14.6667 6.50544 14.6667 7.5C14.6667 8.49456 14.2804 9.44839 13.5927 10.1517C12.9051 10.8549 11.9725 11.25 11 11.25C10.0275 11.25 9.09491 10.8549 8.40728 10.1517C7.71964 9.44839 7.33333 8.49456 7.33333 7.5C7.33333 6.50544 7.71964 5.55161 8.40728 4.84835C9.09491 4.14509 10.0275 3.75 11 3.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashIcon);
export default __webpack_public_path__ + "static/media/cash-icon.ed80767487bc089c1ad37270976f6e37.svg";
export { ForwardRef as ReactComponent };